import React, { useState, useEffect, useContext, useCallback, useRef } from 'react';
import moment from 'moment-timezone';
// import { DataGrid, useGridSlotComponentProps } from '@mui/x-data-grid';
import { FormControl, MenuItem, TablePagination, Tooltip } from '@material-ui/core';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { ReactComponent as WPLogoActive } from '../../../medias/wp_logo_active.svg';
import { ReactComponent as WPLogoCancelled } from '../../../medias/wp_logo_cancelled.svg';
import { makeStyles } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { connect } from 'react-redux';
import api from './Api';

import { BulkActionsContext } from './BulkActionsContext';
import StaffSelect from './StaffSelect';
import config from '../../../config/config';
import {DataGridPro } from '@mui/x-data-grid-pro';
import { GridToolbarExport, GridToolbarContainer, GridToolbarColumnsButton, GridToolbarFilterButton ,useGridSlotComponentProps,useGridApiRef} from '@mui/x-data-grid-pro';
import {isEmpty,cloneDeep } from 'lodash';
import { getRoutesByProductId } from '../../common/actions/routes';
import _ from 'lodash';
import {
    patchBooking,
    deleteOneBookingRoute,
    patchBookingsRoute,
    deleteBookingsRoute,
    bookingSuccess
  } from '../../common/actions/bookings';
  import { Select  } from '@material-ui/core'
import SetRouteBulkActions from 'components/molecules/BulkActions/SetRouteBulkActions';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import { filter, trimEnd } from 'lodash';
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import { formattedDietaries } from 'utils/commonFunction';

const hqURL = config.hqURL;


const useStyles = makeStyles((theme) => ({
    headerCell: { backgroundColor: '#F2F4F7' },
    root: {
        '.MuiDataGrid-columnHeaderCheckbox': {
            backgroundColor: '#F2F4F7',
        },
        '& .MuiDataGrid-main': {
            backgroundColor: '#fff',
            border: '1px solid #ccc',
            borderRadius: '5px',
            textAlign: 'left',
        },
    },
}));

 function BookingsGrid({clearFilter,isBulKAssignOwner,bulkAssign,loggedInUser,getRoutesByProductIdFunc,routes,onSelectACDrawerMenuItemFunc,patchBookingFunc,deleteOneBookingRouteFunc,resetFilter,patchBookingsRouteFunc,deleteBookingsRouteFunc,bookingsUpdated,bookingSuccessFunc}) {
    const classes = useStyles();
    const [bookings, setBookings] = useState([]);
    const { state, dispatch } = useContext(BulkActionsContext);
    const [allBookings, setAllBookings] = useState([]);
    const [filterType, setFilterType] = useState(['ALL']);
    const [staffList, setStaffList] = useState([]);

    const staffNames = staffList.map((s) => s.name)?.sort() || [];
    const CLEAR_STAFF_NAME = '- UNASSIGN -';

    const WPLogoStyle = { width: '30px', height: '30px', marginLeft: '10px' };
    const wpLogoMap = {
        ACTIVE: <WPLogoActive style={WPLogoStyle} />,
        CANCELLED: /*#__PURE__*/ React.createElement(WPLogoCancelled, { style: WPLogoStyle }),
    };


    const [backdropOpen, setbackdropOpen] = useState(false);
    const [backdropMessage, setBackdropMessage] = useState("");
    const myGridRef = useGridApiRef()

    const [routeDialogOpen,setRouteDialogOpen] = useState(false);
    const [selectedRoute,setSelectedRoute] =useState(null)
    const [showConfirmation, setShowConfirmation] = useState(false);
    let prevBookingFilterRef = useRef(state.bookingFilter);
    const clearBookingUpdateSuccess = () =>{
        bookingSuccessFunc(false);
        setShowConfirmation(false);
    }
    useEffect(() => {
        setShowConfirmation(bookingsUpdated);
    }, [bookingsUpdated]);
    const onClickClearBookingRoute=()=>{
        setSelectedRoute("-1");
        setRouteDialogOpen(false); 
      }

    const clearBookingRoute=()=>{
        const updatedBookings=[];
        const bookingIds=[];
        selectedBookings.forEach((booking)=>{
            booking.routeId = null;
            booking.route = {};
            booking.deliveryStatus = 'IN_PROGRESS';
            updatedBookings.push(booking);
            bookingIds.push(booking.id);
        })
        deleteBookingsRouteFunc(bookingIds)
        setSelectedBookings(updatedBookings);
    }




      const onCloseRightModal = () => {
        setRouteDialogOpen(false);
      };

      const onClickAddNewRoute=()=> {
        onSelectACDrawerMenuItemFunc('routes');
      }

      const addBookingRoute =()=>{     
        const updatedBookings=[];
        const assignedRouteBookings=[];
        const route = routes.find((val)=>val.id===selectedRoute);
        selectedBookings.forEach((booking)=>{
        booking.routeId = route.id;
        booking.route = cloneDeep(route);
        booking.deliveryStatus = 'IN_PROGRESS';
        booking = _.set(booking, 'notification.lastCodeSent.isValid', false);
        booking = _.set(booking, 'notification.lastCodeSent.dateTime', moment().toISOString());
        updatedBookings.push(booking.id);
        assignedRouteBookings.push(booking);
        })  
        setSelectedBookings(assignedRouteBookings);
        patchBookingsRouteFunc(updatedBookings,selectedRoute);
      }

      const onSelectRoute=(route)=>{
        setSelectedRoute(route.id);
        setRouteDialogOpen(false);

      }

    const handleChangeRouteAssigned =(e)=>{
        setSelectedRoute(e.target.value)
    }

    const renderSetRoute=(routes,selectedBookings)=> {

        return (
          <SetRouteBulkActions
            routes={routes}
            isModifying={routeDialogOpen}
            onSelectRouteFunc={onSelectRoute}
            onCloseFunc={onCloseRightModal}
            onClickAddNewRoute={onClickAddNewRoute}
            onClickClearBookingRouteFunc={onClickClearBookingRoute}
          />
        );
      }

    const onAssignRouteFunc=()=>{
        if(selectedRoute==="-1"){
            clearBookingRoute()
        return
        }
        addBookingRoute();
    }

    const getTimezoneDate =(params)=>{
            let timeZoneId='UTC'
            let product = {};
            let wheres = [];
            if (params.row.product) {
                product = params.row.product;
                wheres = product.wheres;
            }
            if (params.row.hq && params.row.hq.timezone) {
                timeZoneId = params.row.hq?.timezone;
            } else {
                if (wheres && wheres[0] && wheres[0].timeZoneId) {
                    timeZoneId = wheres[0].timeZoneId;
                } else if (params.row.hq && params.row.hq.location && params.row.hq.location.timeZoneId) {
                    timeZoneId = params.row.hq.location.timeZoneId;
                }
            }
            const eventDateUtc = params.row.hq?.dateTime ? moment.utc(params.row.hq?.dateTime) : moment.utc();
            const eventDate = eventDateUtc.clone().tz(timeZoneId);
            return eventDate;
    }

    const getAlertString=(alert)=> {
        let alertString = '';
        if (alert && !isEmpty(alert)) {
            const { status = '', text } = alert;
            alertString = status === 'active' ? text + ', ' : '';
        }
        return alertString;
    }
    const getPromotionOffAlertString=(sortedAlerts)=> {
        if(!sortedAlerts.length){
            return ''
        }
        let alerts = [];

        const promotionCouponAlerts = filter(sortedAlerts, (a) => {
            return a.type && a.type === 'promotion-coupon';
        });

        if (!isEmpty(promotionCouponAlerts)) {
            alerts.push(getAlertString(promotionCouponAlerts[0]));
        }

        let alertString = trimEnd(alerts.join(''), ', ');

        return !isEmpty(alertString) ? alertString + '' : '';
    }
 
    


    function getRequiredColumns(bulkAssign){
        let columns
        switch(bulkAssign){
            case 'Assign an Owner':
                 columns = [
                    {
                        field: 'hqId',
                        headerClassName: classes.headerCell,
                        headerName: 'HQ ID',
                        width: 110,
                        editable: false,
                        renderCell: (params) => {
                            const url = `${hqURL}/events/` + params.row.hqId;
                            return (
                                <a target="_blank" rel="noopener noreferrer" href={url}>
                                    {params.row.hqId}
                                </a>
                            );
                        },
                    },
                    {
                        field: 'bookingStatus',
                        headerClassName: classes.headerCell,
                        headerName: 'Status',
                        minWidth: 110,
                        flex: 0,
                        editable: false,
                        valueGetter: (params) => params.row.hq?.status,
                        renderCell: (params) => {
                            const url = '/planner?hqId=' + params.row.hqId;
                            const display = params.value?.charAt(0).toUpperCase() + params.value?.slice(1);
                            return (
                                <a target="_blank" rel="noopener noreferrer" href={url}>
                                    {display}
                                </a>
                            );
                        },
                    },
                    {
                        field: 'bookingDate',
                        headerClassName: classes.headerCell,
                        headerName: 'Date',
                        type: 'date',
                        editable: false,
                        valueGetter: (params) => getTimezoneDate(params),
                        valueFormatter: (params) => {
                            return moment(params.value).format('ddd DD MMM YY');
                        },
                        minWidth: 180,
                        flex: 0,
                    },
                    {
                        field: 'bookingRoute',
                        headerClassName: classes.headerCell,
                        headerName: 'Experience',
                        editable: false,
                        valueGetter: (params) => params.row.product?.name,
                        renderCell: (params) => {
                            return (
                                <Tooltip title={params.row.product?.name}>
                                    <span>{params.row.product?.name}</span>
                                </Tooltip>
                            );
                        },
                        flex: 1,
                    },
                    {
                        field: 'bookingPax',
                        headerClassName: classes.headerCell,
                        headerName: 'Pax',
                        editable: false,
                        valueGetter: (params) =>
                            parseInt(params.row.hq?.adultsCount || 0) + parseInt(params.row.hq?.kidsCount || 0),
                        valueFormatter: (params) => `${params.row.hq?.adultsCount || 0}/${params.row.hq?.kidsCount || 0}`,
                        flex: 0,
                        align: 'center',
                    },
                    {
                        field: 'customerName',
                        headerClassName: classes.headerCell,
                        headerName: 'Customer Name',
                        editable: false,
                        valueGetter: (params) => `${params.row.hq?.customer?.name}`,
                        valueSetter: (params) => {
                            const val = {
                                ...params.row,
                                hq: { ...params.row.hq, customer: { ...params.row.customer, name: params.value } },
                            };
                            return val;
                        },
                        flex: 1,
                    },
                    {
                        field: 'customerSubscriptionStatus',
                        headerClassName: classes.headerCell,
                        headerName: 'Sub',
                        editable: false,
                        valueGetter: (params) => `${params.row.subscriptionStatus || '-'}`,
                        renderCell: (params) => wpLogoMap[params.row.subscriptionStatus] || '-',
                        flex: 0,
                        align: 'center',
                    },
                    {
                        field: 'userId',
                        headerClassName: classes.headerCell,
                        headerName: 'Owner',
                        width: 150,
                        editable: true,
                        type: 'singleSelect',
                        valueOptions: [CLEAR_STAFF_NAME, ...staffNames],
            
                        valueParser: (value) => {
                            if (value === CLEAR_STAFF_NAME) {
                                return undefined;
                            } else {
                                const val = staffList.find((s) => s.name === value)?.id;
                                return val;
                            }
                        },
                        valueFormatter: (params) => {
                            if (params.row.userId) {
                                const staff = staffList.find((s) => s.id === params.row.userId);
                                if (staff) {
                                    return staff.name;
                                } else {
                                    return 'ERR - ' + params.row.userId;
                                }
                            } else {
                                return '-';
                            }
                        },
                        // getApplyFilterFn: (filterItem, column) => {
            
                        // },
                    },
                ];
                return columns;
                
            case 'Send gameplay':
                columns = [
                    {
                        field: 'hqId',
                        headerClassName: classes.headerCell,
                        headerName: 'HQ ID',
                        width: 100,
                        editable: false,
                        renderCell: (params) => {
                            const url = `${hqURL}/events/` + params.row.hqId;
                            return (
                                <a target="_blank" rel="noopener noreferrer" href={url}>
                                    {params.row.hqId}
                                </a>
                            );
                        },
                    },
                    {
                        field: 'bookingStatus',
                        headerClassName: classes.headerCell,
                        headerName: 'Status',
                        minWidth: 100,
                        flex: 0,
                        editable: false,
                        valueGetter: (params) => params.row.hq?.status,
                        renderCell: (params) => {
                            const url = '/planner?hqId=' + params.row.hqId;
                            const display = params.value?.charAt(0).toUpperCase() + params.value?.slice(1);
                            return (
                                <a target="_blank" rel="noopener noreferrer" href={url}>
                                    {display}
                                </a>
                            );
                        },
                    },
                    {
                        field: 'bookingDate',
                        headerClassName: classes.headerCell,
                        headerName: 'Date',
                        editable: false,
                        valueGetter: (params) => getTimezoneDate(params),
                        valueFormatter: (params) => {
                            return moment(params.value).format('ddd DD MMM YY');
                        },
                        minWidth: 110,
                        flex: 0,
                    },
                    {
                        field: 'bookingRoute',
                        headerClassName: classes.headerCell,
                        headerName: 'Experience',
                        editable: false,
                        valueGetter: (params) => params.row.product?.name,
                        renderCell: (params) => {
                            return (
                                <Tooltip title={params.row.product?.name}>
                                    <span>{params.row.product?.name}</span>
                                </Tooltip>
                            );
                        },
                        flex: 1,
                    },
                    {
                        field: 'customerSubscriptionStatus',
                        headerClassName: classes.headerCell,
                        headerName: 'Sub',
                        editable: false,
                        valueGetter: (params) => `${params.row.subscriptionStatus || '-'}`,
                        renderCell: (params) => wpLogoMap[params.row.subscriptionStatus] || '-',
                        flex: 0,
                        align: 'center',
                    },
                    {
                        field: 'isPersonalisationDone',
                        headerClassName: classes.headerCell,
                        headerName: 'Personalisation Complete',
                        editable: false,
                        valueGetter: (params) => `${params?.row?.isPersonalisationDone || '-'}`,
                        renderCell: (params) => params?.row?.isPersonalisationDone ? 'Done' : '',
                        flex: 0,
                        align: 'center',
                    },
                    {
                        field: 'note',
                        headerClassName: classes.headerCell,
                        headerName: 'Booking Notes',
                        editable: false,
                        valueGetter: (params) => params?.row?.note?.private,
                        renderCell: (params) => {
                            return (
                                <Tooltip title={params?.row?.note?.private|| '-'}>
                                    <span>{params?.row?.note?.private|| '-'}</span>
                                </Tooltip>
                            );
                        },
                        flex: 0,
                    },
                    {
                        field: 'route',
                        headerClassName: classes.headerCell,
                        headerName: 'Route Assigned',
                        editable: false,
                        valueGetter: (params) => (params) => params.row?.route?.name !== undefined? `${params.row?.route?.name}`:'',
                        renderCell: (params) => {
                            return (
                                <Tooltip title={params?.row?.route?.name || '-'}>
                                    <span>{params?.row?.route?.name || '-'}</span>
                                </Tooltip>
                            );
                        },
                        flex: 0,
                    },
                    {
                        field: 'isCodeSent',
                        headerClassName: classes.headerCell,
                        headerName: 'Code Sent',
                        editable: false,
                        valueGetter: (params) => params?.row?.notification?.lastCodeSent?.isValid,
                        renderCell: (params) => params?.row?.notification?.lastCodeSent?.isValid?'Yes':'No' || '-',
                        flex: 0,
                    },
                    {
                        field: 'userId',
                        headerClassName: classes.headerCell,
                        headerName: 'Owner',
                        width: 110,
                        editable: true,
                        type: 'singleSelect',
                        valueOptions: [CLEAR_STAFF_NAME, ...staffNames],
            
                        valueParser: (value) => {
                            if (value === CLEAR_STAFF_NAME) {
                                return undefined;
                            } else {
                                const val = staffList.find((s) => s.name === value)?.id;
                                return val;
                            }
                        },
                        valueFormatter: (params) => {
                            if (params.row.userId) {
                                const staff = staffList.find((s) => s.id === params.row.userId);
                                if (staff) {
                                    return staff.name;
                                } else {
                                    return 'ERR - ' + params.row.userId;
                                }
                            } else {
                                return '-';
                            }
                        },
                        // getApplyFilterFn: (filterItem, column) => {
            
                        // },
                    },
                ];
                return columns;
            case 'Assign Routes':
                 columns = [
                {
                    field: 'hqId',
                    headerClassName: classes.headerCell,
                    headerName: 'HQ ID',
                    width:80,
                    editable: false,
                    renderCell: (params) => {
                        const url = `${hqURL}/events/` + params.row.hqId;
                        return (
                            <a target="_blank" rel="noopener noreferrer" href={url}>
                                {params.row.hqId}
                            </a>
                        );
                    },
                },
                {
                    field: 'bookingStatus',
                    headerClassName: classes.headerCell,
                    headerName: 'Status',
                    minWidth: 80,
                    flex: 0,
                    editable: false,
                    valueGetter: (params) => params.row.hq?.status,
                    renderCell: (params) => {
                        const url = '/planner?hqId=' + params.row.hqId;
                        const display = params.value?.charAt(0).toUpperCase() + params.value?.slice(1);
                        return (
                            <a target="_blank" rel="noopener noreferrer" href={url}>
                                {display}
                            </a>
                        );
                    },
                },
                {
                    field: 'bookingDate',
                    headerClassName: classes.headerCell,
                    headerName: 'Date',
                    editable: false,
                    valueGetter: (params) => getTimezoneDate(params),
                    valueFormatter: (params) => {
                        return moment(params.value).format('ddd DD MMM YY');
                    },
                    minWidth: 100,
                    flex: 0,
                },
                {
                    field: 'bookingRoute',
                    headerClassName: classes.headerCell,
                    headerName: 'Experience',
                    editable: false,
                    valueGetter: (params) => params.row.product?.name,
                    renderCell: (params) => {
                        return (
                            <Tooltip title={params.row.product?.name}>
                                <span>{params.row.product?.name}</span>
                            </Tooltip>
                        );
                    },
                    flex: 1,
                    minWidth: 200
                },
                {
                    field: 'routes',
                    headerClassName: classes.headerCell,
                    headerName: 'Route Assigned',
                    editable: false,
                    valueGetter: (params) => params.row?.route?.name !== undefined? `${params.row?.route?.name}`:'',
                    renderCell: (params) => {
                        return (
                            <Tooltip title={params.row?.route?.name}>
                                <span>{params.row?.route?.name||'-'}</span>
                            </Tooltip>
                        );
                    },
                    flex: 1,
                    minWidth: 200,
                },
                {
                    field: 'customerSubscriptionStatus',
                    headerClassName: classes.headerCell,
                    headerName: 'Sub',
                    editable: false,
                    valueGetter: (params) => `${params.row.subscriptionStatus || '-'}`||'',
                    renderCell: (params) => wpLogoMap[params.row.subscriptionStatus] || '-',
                    flex: 0,
                    align: 'center',
                },
                {
                    field: 'bookingPax',
                    headerClassName: classes.headerCell,
                    headerName: 'Pax',
                    editable: false,
                    valueGetter: (params) =>
                        parseInt(params.row.hq?.adultsCount || 0) + parseInt(params.row.hq?.kidsCount || 0),
                    valueFormatter: (params) => `${params.row.hq?.adultsCount || 0}/${params.row.hq?.kidsCount || 0}`,
                    flex: 0,
                    align: 'center',
                    minWidth: 100,
                },
                {
                    field: 'addOns',
                    headerClassName: classes.headerCell,
                    headerName: 'Add Ons',
                    editable: false,
                    valueGetter: (params) => `${params.row.hq?.extras?.addOns}`,
                    renderCell: (params) =>  params.row.hq?.extras?.addOns||'',
                    flex: 1,
                    minWidth: 100,

                },
                {
                    field: 'attendeeDietaries',
                    headerClassName: classes.headerCell,
                    headerName: 'Dietaries',
                    editable: false,
                    valueGetter: (params) => params.row?.attendeeDietaries !== undefined? `${params.row?.attendeeDietaries}`:'',
                    renderCell: (params) => {
                        return (
                            <Tooltip title={params.row?.attendeeDietaries}>
                                <span>{params.row?.attendeeDietaries||''}</span>
                            </Tooltip>
                        );
                    },
                    flex: 1,
                    minWidth: 200,
                },
                {
                    field: 'allergy',
                    headerClassName: classes.headerCell,
                    headerName: 'Allergies',
                    editable: false,
                    valueGetter: (params) => params.row.hq?.dietaries?.allergy !==null?`${params.row.hq?.dietaries?.allergy}`:'',
                    renderCell: (params) =>  params.row.hq?.dietaries?.allergy||'',
                    flex: 1,
                    minWidth: 100,

                },
                {
                    field: 'alerts',
                    headerClassName: classes.headerCell,
                    headerName: 'Promotions',
                    editable: false,
                    valueGetter: (params) => params.row?.alerts? getPromotionOffAlertString(params.row.alerts):[],
                    renderCell: (params) => {
                      const alertString = getPromotionOffAlertString(params.row?.alerts||[]);
                      return (
                        <Tooltip title={alertString}>
                          <span>{alertString}</span>
                        </Tooltip>
                      );
                    },
                    flex: 1,
                    minWidth: 100,
                  },
                  
                {
                    field: 'userId',
                    headerClassName: classes.headerCell,
                    headerName: 'Owner',
                    width: 150,
                    editable: true,
                    type: 'singleSelect',
                    valueOptions: [CLEAR_STAFF_NAME, ...staffNames],
        
                    valueParser: (value) => {
                        if (value === CLEAR_STAFF_NAME) {
                            return undefined;
                        } else {
                            const val = staffList.find((s) => s.name === value)?.id;
                            return val;
                        }
                    },
                    valueFormatter: (params) => {
                        if (params.row.userId) {
                            const staff = staffList.find((s) => s.id === params.row.userId);
                            if (staff) {
                                return staff.name;
                            } else {
                                return 'ERR - ' + params.row.userId;
                            }
                        } else {
                            return '-';
                        }
                    },
                },
                {
                    field: 'private',
                    headerClassName: classes.headerCell,
                    headerName: 'Booking Notes',
                    editable: false,
                    valueGetter: (params) =>params?.row?.note?.private !== undefined? `${params?.row?.note?.private}`:'',
                    renderCell: (params) => {
                        return (
                            <Tooltip title={params?.row?.note?.private}>
                                <span>{params?.row?.note?.private||'-'}</span>
                            </Tooltip>
                        );
                    },
                    flex: 1,
                    minWidth: 100,

                },
                   
                    // getApplyFilterFn: (filterItem, column) => {
        
                    // },
                
            ];
            return columns;
            default:
                return columns = [
                    {
                        field: 'hqId',
                        headerClassName: classes.headerCell,
                        headerName: 'HQ ID',
                        width: 110,
                        editable: false,
                        renderCell: (params) => {
                            const url = `${hqURL}/events/` + params.row.hqId;
                            return (
                                <a target="_blank" rel="noopener noreferrer" href={url}>
                                    {params.row.hqId}
                                </a>
                            );
                        },
                    },
                    {
                        field: 'bookingStatus',
                        headerClassName: classes.headerCell,
                        headerName: 'Status',
                        minWidth: 110,
                        flex: 0,
                        editable: false,
                        valueGetter: (params) => params.row.hq?.status,
                        renderCell: (params) => {
                            const url = '/planner?hqId=' + params.row.hqId;
                            const display = params.value?.charAt(0).toUpperCase() + params.value?.slice(1);
                            return (
                                <a target="_blank" rel="noopener noreferrer" href={url}>
                                    {display}
                                </a>
                            );
                        },
                    },
                    {
                        field: 'bookingDate',
                        headerClassName: classes.headerCell,
                        headerName: 'Date',
                        editable: false,
                        valueGetter: (params) => params.row.hq?.dateTime,
                        valueFormatter: (params) => {
                            return moment(params.value).format('ddd DD MMM YY');
                        },
                        minWidth: 180,
                        flex: 0,
                    },
                    {
                        field: 'bookingRoute',
                        headerClassName: classes.headerCell,
                        headerName: 'Experience',
                        editable: false,
                        valueGetter: (params) => params.row.product?.name,
                        renderCell: (params) => {
                            return (
                                <Tooltip title={params.row.product?.name}>
                                    <span>{params.row.product?.name}</span>
                                </Tooltip>
                            );
                        },
                        flex: 1,
                    },
                    {
                        field: 'bookingPax',
                        headerClassName: classes.headerCell,
                        headerName: 'Pax',
                        editable: false,
                        valueGetter: (params) =>
                            parseInt(params.row.hq?.adultsCount || 0) + parseInt(params.row.hq?.kidsCount || 0),
                        valueFormatter: (params) => `${params.row.hq?.adultsCount || 0}/${params.row.hq?.kidsCount || 0}`,
                        flex: 0,
                        align: 'center',
                    },
                    {
                        field: 'customerName',
                        headerClassName: classes.headerCell,
                        headerName: 'Customer Name',
                        editable: false,
                        valueGetter: (params) => `${params.row.hq?.customer?.name}`,
                        valueSetter: (params) => {
                            const val = {
                                ...params.row,
                                hq: { ...params.row.hq, customer: { ...params.row.customer, name: params.value } },
                            };
                            return val;
                        },
                        flex: 1,
                    },
                    {
                        field: 'customerSubscriptionStatus',
                        headerClassName: classes.headerCell,
                        headerName: 'Sub',
                        editable: false,
                        valueGetter: (params) => `${params.row.subscriptionStatus || '-'}`,
                        renderCell: (params) => wpLogoMap[params.row.subscriptionStatus] || '-',
                        flex: 0,
                        align: 'center',
                    },
                    {
                        field: 'userId',
                        headerClassName: classes.headerCell,
                        headerName: 'Owner',
                        width: 150,
                        editable: true,
                        type: 'singleSelect',
                        valueOptions: [CLEAR_STAFF_NAME, ...staffNames],
            
                        valueParser: (value) => {
                            if (value === CLEAR_STAFF_NAME) {
                                return undefined;
                            } else {
                                const val = staffList.find((s) => s.name === value)?.id;
                                return val;
                            }
                        },
                        valueFormatter: (params) => {
                            if (params.row.userId) {
                                const staff = staffList.find((s) => s.id === params.row.userId);
                                if (staff) {
                                    return staff.name;
                                } else {
                                    return 'ERR - ' + params.row.userId;
                                }
                            } else {
                                return '-';
                            }
                        },
                        // getApplyFilterFn: (filterItem, column) => {
            
                        // },
                    },
                ];
        }
    }

    

    function getFilteredBookings(bookingList = [], products = [], filterType = '') {
        const excluded = [];
        let filteredRows = bookingList.filter((b) => {
            let match = true;
            if (products.length > 0) {
                match =
                    match &&
                    products.filter((r) => {
                        return r.id === b.product?.id;
                    }).length > 0;
            } else {
                match = false;
            }
            if (!match) {
                excluded.push(b);
            }
            return match;
        });

        switch (filterType) {
            case 'ALL':
                break;
            case 'ASSIGNED':
                filteredRows = filteredRows.filter((b) => {
                    return b.userId;
                });
                break;
            case 'UNASSIGNED':
                filteredRows = filteredRows.filter((b) => {
                    return !b.userId;
                });
                break;
            default:
                break;
        }
        return filteredRows;
    }

    function dataGridToolbar() {
        return (
          <GridToolbarContainer style={{paddingTop: '10px'}}>
            <GridToolbarColumnsButton style={{color: '#434F69'}} />
            <GridToolbarFilterButton style={{color: '#434F69'}}/>
            <GridToolbarExport style={{color: '#434F69'}}/>
          </GridToolbarContainer>
        );
    }

    const filterStaff = (newFilter) => {
        // const searchRegex = new RegExp(escapeRegExp(searchValue), 'i');
        setFilterType(newFilter);
    };

    const handleCellEditCommit = useCallback(
        async ({ id, field, value }) => {
            let updatedRows = undefined;
            try {
                if (field === 'userId') {
                    updatedRows = allBookings.map((row) => {
                        if (row.id === id) {
                            return { ...row, userId: value };
                        }
                        return row;
                    });
                    await api.putBookingManager(id, value);
                }
            } catch (e) {
                console.error('Error updating Booking : ', e);
                alert('Error updating Owner : ' + e?.toString() || 'Unknown error');
                updatedRows = undefined;
            }
            if (updatedRows) {
                setAllBookings(updatedRows);
            }
        },
        [allBookings]
    );

    useEffect(() => {
        const bookings = getFilteredBookings(allBookings, state.productListFilter, filterType);
        setBookings(bookings);
    }, [allBookings, state.productListFilter, filterType]);

    useEffect(() => {
        const getData = async () => {
            const data = await api.getStaff();
            setStaffList(data);
        };

        getData();
    }, []);


    const handleClearFilters = useCallback(() => {
        if (myGridRef && myGridRef.current) {
        const currentState = myGridRef.current.getState();
        currentState.filter.items=[];
        }
      }, [myGridRef]);
      
    useEffect(() => {
        handleClearFilters();
      }, [clearFilter, handleClearFilters]);

    useEffect(() => {
        async function getData() {
            if (state.bookingFilter?.startDate && state.bookingFilter?.endDate) {
                setbackdropOpen(true);
                const data = await api.getBookings(state.bookingFilter);
                const mappedData = mapAttendeeDietariesToBookings({data});
                setAllBookings(mappedData);
                setbackdropOpen(false);
            }
        }
        
        // if (!_.isEqual(prevBookingFilterRef.current, state.bookingFilter)) {
            getData();
        //   }
          prevBookingFilterRef.current = state.bookingFilter;
    }, [state.bookingFilter, dispatch]);

    const [selectionModel, setSelectionModel] = React.useState([]);
    const [selectedBookings, setSelectedBookings] = React.useState([]);
    const [sameProduct, setSameProduct] = React.useState(false);

    useEffect(() => {
        setShowConfirmation(false)
        dispatch({ type: 'setSelectedBookings', selectedBookinsIdList: selectionModel });
    }, [selectionModel, dispatch]);

    useEffect(()=>{
        setSelectedRoute(null)
    },[selectionModel])
    function separateBookingsById(bookings, bookingIds) {
        const separatedBookings = [];
      
        for (const booking of bookings) {
          if (bookingIds.includes(booking.id)) {
            separatedBookings.push(booking);
          }
        }
        return separatedBookings;
    }

    function checkSameProduct(bookings) {
        if (bookings.length === 0) {
          return false;
        }
      
        const productId = bookings[0].product.id;
      
        for (let i = 1; i < bookings.length; i++) {
          if (bookings[i].product.id !== productId) {
            return false;
          }
        }
      
        return {
            productId,
            isSameProduct:true
        };
      }
      

    useEffect(()=>{
        const selectedBookings = separateBookingsById(bookings,selectionModel);
        setSelectedBookings(selectedBookings);
        const {isSameProduct,productId} = checkSameProduct(selectedBookings);
        setSameProduct(isSameProduct);
        if(isSameProduct){
            getRoutesByProductIdFunc(productId);
        }

    },[selectionModel,getRoutesByProductIdFunc,bookings])

    const [isModalOpen, setIsModalOpen] = useState(false);
    const overwriteCount = useRef(0);
    const bulkAssignStaffId = useRef(undefined);


    const handleModalClose = (selectedValue) => {
        setIsModalOpen(false);
        if (selectedValue) {
            performBulkAssign();
        }
    };

    async function performBulkAssign() {
        const results = selectionModel.map(async (id) => {
            return await api.putBookingManager(id, bulkAssignStaffId.current);
        });

        await Promise.all(results);

        setbackdropOpen(true);
        const newBookings = await api.getBookings(state.bookingFilter);
        setbackdropOpen(false);
        setSelectionModel([]);
        setAllBookings(newBookings);
    }

    function bulkAssignClicked(staffId) {
        const overwrites = selectionModel.filter((id) => {
            const b = bookings.find((b) => b.id === id);
            if (b && b.userId && b.userId !== 'undefined') {
                return true;
            } else {
                return false;
            }
        });

        if (staffId === '-1') {
            // Unassign staff
            bulkAssignStaffId.current = undefined;
        } else {
            bulkAssignStaffId.current = staffId;
        }
        overwriteCount.current = overwrites.length;

        if (overwriteCount.current === 0) {
            performBulkAssign();
        } else {
            setIsModalOpen(true);
        }
    }

    async function handleSendGameplayAction() {
        try {
            setbackdropOpen(true);
            setBackdropMessage("Bulk send in progress, please do not refresh or close this browser window");
            const selectedBookings = bookings.filter((item) => selectionModel.indexOf(item.id) !== -1);
            const actorData = {
                type: 'email',
                userGivenName: loggedInUser,
            };

            await api.sendBulkGamePlay(selectedBookings, actorData);
            setBackdropMessage("");
            const newBookings = await api.getBookings(state.bookingFilter);
            setbackdropOpen(false);
            setSelectionModel([]);
            setAllBookings(newBookings);
        } catch (e) {
            setbackdropOpen(false);
            alert('There was an unexpected error sending bookings.')
        }
    }

    const [maxBookingLimit, setMaxBookingLimit] = useState(false);
    useEffect(() => {
        setMaxBookingLimit(bookings.length >= api.maxBookingCount);
    }, [bookings]);

    return (
        <div style={{ height: '100%', margin: '10px 20px' }}>
            <ClickAwayListener onClickAway={clearBookingUpdateSuccess}>
                 <Snackbar
                    open={showConfirmation}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    // autoHideDuration={3000}
                    onClose={() => clearBookingUpdateSuccess()}
                >
                    <Alert variant="filled" severity="success" autoHideDuration={1000} onClose={() => clearBookingUpdateSuccess()}>
                     Route has been attached.
                    </Alert>
                </Snackbar>
                </ClickAwayListener>        
            {maxBookingLimit && (
                <div>
                    <b>Warning : </b>The number of bookings matching your query exceeds the maximum number of rows in
                    the table. Please refine your filters.
                </div>
            )}
            <ConfirmDialog
                countUpdates={overwriteCount.current || 0}
                open={isModalOpen}
                handleClose={handleModalClose}
            />
            <DataGridPro
                apiRef={myGridRef}
                rows={bookings}
                columns={getRequiredColumns(bulkAssign)}
                pageSize={100}
                rowsPerPageOptions={[100]}
                loglevel="debug"
                density="compact"
                className={classes.root}
                onCellEditCommit={handleCellEditCommit}
                checkboxSelection
                disableSelectionOnClick
                pagination
                components={{
                    // ColumnMenu: CustomColumnMenu,
                    Toolbar: dataGridToolbar,
                    Footer: (params) => {
                        return (
                            <BulkActionsFooter
                                staffList={staffList}
                                selectedRowCount={selectionModel?.length || 0}
                                handleAction={bulkAssignClicked}
                                isBulKAssignOwner={isBulKAssignOwner}
                                handleSendGameplayAction={handleSendGameplayAction}
                                selectedModel={selectionModel}
                                bookings={bookings}
                                loggedInUser={loggedInUser}
                                bulkAssign={bulkAssign}
                                routeDialogOpen={routeDialogOpen}
                                setRouteDialogOpen={setRouteDialogOpen}
                                sameProduct={sameProduct}
                                selectedBookings={selectedBookings}
                                routes={routes}
                                handleChangeRouteAssigned={handleChangeRouteAssigned}
                                selectedRoute={selectedRoute}
                                onAssignRouteFunc={onAssignRouteFunc}
                            />
                        );
                    },
                    Pagination: CustomPagination,
                }}
                componentsProps={{ columnMenu: { filterStaff } 
                  }}
                onSelectionModelChange={(newSelectionModel) => {
                    clearBookingUpdateSuccess();
                    setSelectionModel(newSelectionModel);
                }}
                selectionModel={selectionModel}
                onSelectionChange={(newSelection) => {
                    // setSelection(newSelection.rows);
                }}
            />

            <Backdrop style={{ color: '#fff', zIndex: 1 }} open={backdropOpen}>
                <div>
                    {backdropMessage && <div style={{marginBottom: "30px"}}>{backdropMessage}</div>}
                    <div>
                        <CircularProgress color="inherit" />
                    </div>
                </div>
            </Backdrop>
            {routeDialogOpen?renderSetRoute(routes,selectedBookings):''}
        </div>
    );
}



function BulkActionsFooter({ staffList, selectedRowCount, handleAction ,isBulKAssignOwner,handleSendGameplayAction,selectedModel,bulkAssign,routeDialogOpen,setRouteDialogOpen,sameProduct,routes,handleChangeRouteAssigned,selectedRoute,onAssignRouteFunc}) {
    const [selectedStaff, setSelectedStaff] = useState();

    const onStaffSelected = (value) => {
        setSelectedStaff(value?.id);
    };

    const optionList = [{ id: '-1', name: ' - UNASSIGN -' }, ...staffList];
    let routesOptionList =[{ id: '-1', name: ' - CLEAR -' }]
    if(!isEmpty(routes)){
        routesOptionList= [{ id: '-1', name: ' - CLEAR -' }, ...routes];
    }

    function footerContent(){

        switch(bulkAssign){
            case 'Assign an Owner':
    return (
                <div style={{ alignSelf: 'flex-start', padding: '16px', display: 'flex', alignItems: 'center' }}>
                    {' '}
                    Assign To
                    <FormControl variant="outlined" size="small" style={{ width: '200px', marginRight: '20px' }}>
                        <StaffSelect staffList={optionList} onStaffSelected={onStaffSelected} />
                    </FormControl>
                    <Button variant="contained" onClick={() => handleAction(selectedStaff)} disabled={!selectedStaff}>
                        Assign {selectedRowCount} Bookings{' '}
                    </Button>
                </div>
                )
            case 'Send gameplay':
                return(
                <div style={{ alignSelf: 'flex-start', padding: '16px', display: 'flex', alignItems: 'center' }}>
                    <Button
                        variant="contained"
                        onClick={() => {
                            handleSendGameplayAction();
                        }}
                    >
                        Send gameplay for {selectedRowCount} bookings
                    </Button>
                </div>
                )
            case 'Assign Routes':
                return(
                    
                <div style={{ alignSelf: 'flex-start', padding: '16px', display: 'flex', alignItems: 'center' }}>
                    {' '}
                    Assign
                    <div style={{marginLeft:'20px'}}>
                    {
                        selectedRoute&&
                        <FormControl  size="small">
                            <Select
                                value={selectedRoute}
                                label="Assigned Route"
                                onChange={handleChangeRouteAssigned}
                                style={{ width: '200px', marginRight: '20px' }}
                            >
                                {routesOptionList.map((s) =>
                                    (<MenuItem key={s.id} value={s.id}>{s.name}</MenuItem>)
            )}
                            </Select>
                        </FormControl> 
                     } 
                     {
                      selectedRoute && 
                        <Button variant="contained"
                                 onClick={()=>{
                                    onAssignRouteFunc()
                                 }
                                    
                                }
                                 disabled={!sameProduct}>
                            Assign {selectedRowCount} Bookings
                        </Button>
                     }{!selectedRoute &&
                        <Button variant="contained" onClick={() => setRouteDialogOpen(!routeDialogOpen)} disabled={!sameProduct}>
                            Select Route
                        </Button>
                     }
                     
                  
        </div>
                    {!sameProduct?<span style={{marginLeft:'10px',color:'red'}}>Multiple Product Id</span>:''}
                    
                </div>
                )
    
            default :
            return (
                <>
                </>
            )
        }
    
    }

    return (
        <div
            style={{
                display: 'flex',
                felxDirection: 'row',
                justifyContent: 'left',
                height: '80px',
                alignItems: 'center',
                marginTop: '40px',
                borderRadius: '5px',
                border: '1px solid #ccc',
                backgroundColor: '#fff',
            }}
        >
            <CustomPagination style={{ alignSelf: 'flex-end' }} />
            {!selectedRowCount ? null : footerContent()}
        </div>
    );
}

function CustomPagination() {
    const { state, apiRef, options } = useGridSlotComponentProps();
    return (
        <TablePagination
            count={state.pagination.rowCount}
            page={state.pagination.page}
            onPageChange={(event, value) => apiRef.current.setPage(value)}
            rowsPerPage={options.pageSize}
            rowsPerPageOptions={[]}
        />
    );
}

function ConfirmDialog({ countUpdates, open, handleClose }) {
    return (
        <Dialog open={open} onClose={handleClose} aria-labelledby="responsive-dialog-title">
            <DialogTitle id="responsive-dialog-title">{'Bulk Assign'}</DialogTitle>
            <DialogContent>
                <DialogContentText>This will overwrite {countUpdates} bookings.</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={() => handleClose(false)}>
                    Cancel
                </Button>
                <Button onClick={() => handleClose(true)} autoFocus>
                    Continue
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function mapAttendeeDietariesToBookings({
    data
}) {
    let mappedBookings = data?.map(booking => {
        const { experiencePersonalisationDetails } = booking;
        let attendeeDietaries = null;
        if(!isEmpty(experiencePersonalisationDetails)) {
            const attendeeInformationResponse = experiencePersonalisationDetails?.userResponse?.sections?.[0]?.questions?.find(question => question?.configurationData?.questionCode === "attendee_information");
            const result = formattedDietaries(attendeeInformationResponse);
            attendeeDietaries = result?.join(' • ');
       }
        return {
            ...booking,
            attendeeDietaries
        }
    });
    return mappedBookings;
}

const mapDispatchToProps = (dispatch) => {
    return {
      getRoutesByProductIdFunc: (productId) => dispatch(getRoutesByProductId(productId)),
      patchBookingFunc: (booking) => dispatch(patchBooking(booking)),
      deleteOneBookingRouteFunc: (bookingId) => dispatch(deleteOneBookingRoute(bookingId)),
      patchBookingsRouteFunc:(bookingids,routeId)=>dispatch(patchBookingsRoute(bookingids,routeId)),
      deleteBookingsRouteFunc: (bookingIds) => dispatch(deleteBookingsRoute(bookingIds)),
      bookingSuccessFunc: (value) => dispatch(bookingSuccess(value)),
    };
  };
  
  const mapStateToProps = (state) => {
    const stateRoutes = state.routes;
    const bookingsUpdated = state.bookings.refreshBookings;
    let routes;
    let route;
  
    if (stateRoutes) {
      if (stateRoutes.error) {
        console.error(stateRoutes.error.message);
      }
      if (stateRoutes.routes) {
        routes = stateRoutes.routes.data;
      }
      if (stateRoutes.route) {
        route = stateRoutes.route.data;
      }

    }
  
    return {
      routes,
      route,
      bookingsUpdated
    };
  };
export default connect(mapStateToProps, mapDispatchToProps)(BookingsGrid);